import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = {
  key: 0,
  class: "help is-danger"
}

import Modal from '@/shared/components/Modal.vue';
import appInsights from '@/shared/services/appInsights';
import Toast from '@/shared/services/toast';
import { AnswerViewModel } from '@/features/bots/models/answers/answerViewModel';
import { CREATE_ANSWER } from '@/store/answers/actionTypes';
import { CreateAnswerViewModel } from '@/features/bots/models/answers/createAnswerViewModel';
import { useStore } from 'vuex';
import { computed, onMounted, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { maxLength, required } from '@vuelidate/validators';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddAnswerModal',
  emits: ["answer-added", "close"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const createAnswer = (request: CreateAnswerViewModel): Promise<AnswerViewModel> =>
  store.dispatch(CREATE_ANSWER, request);

const faqTitle = ref('');
const isLoading = ref(false);
const faqNameInput = ref<HTMLInputElement | null>(null);

const emit = __emit;

const validations = {
  faqTitle: {
    required,
    validFaqTitle: (value: string) => value.search(/[<>*%&:\\$]/) === -1,
    maxLength: maxLength(50),
  },
};

const $v = useVuelidate(validations, { faqTitle });

onMounted(() => {
  if (faqNameInput.value) {
    faqNameInput.value.focus();
  }
});

async function addFAQ() {
  if ($v.value.$invalid) {
    return;
  }

  appInsights.trackEvent({ name: 'Add answer clicked' }, { workspaceId: currentWorkspace.value.id });
  isLoading.value = true;
  try {
    faqTitle.value = faqTitle.value.trim();
    const createdAnswer = await createAnswer({ title: faqTitle.value });
    isLoading.value = false;
    emit('answer-added', createdAnswer);
    close();
  } catch (ex: any) {
    isLoading.value = false;
    if (ex.status === 409) {
      Toast.showError(`Failed to add FAQ - "${faqTitle.value}" already exists`);
    } else {
      Toast.showError('Failed to add FAQ');
    }
  }
}

function getErrorMessage(): string {
  if ($v.value.faqTitle.required.$invalid) {
    return 'Must not be empty';
  }

  if ($v.value.faqTitle.validFaqTitle.$invalid) {
    return 'Must not contain <, >, *, %, &, :, \\, $';
  }
  if ($v.value.faqTitle.maxLength.$invalid) {
    return 'Must not be longer than 50 characters';
  }

  return '';
}

function close() {
  emit('close');
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createBlock(Modal, { onCancel: close }, {
    title: _withCtx(() => _cache[2] || (_cache[2] = [
      _createElementVNode("p", { class: "modal-card-title" }, "Add a new FAQ", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("label", {
          for: "answer-modal-title-input",
          class: "label"
        }, "Frequently Asked Question", -1)),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            id: "answer-modal-title-input",
            ref_key: "faqNameInput",
            ref: faqNameInput,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((faqTitle).value = $event)),
            class: _normalizeClass(["input", { 'is-danger': _unref($v).faqTitle.$invalid && _unref($v).faqTitle.$dirty }]),
            type: "text",
            placeholder: "Enter the Frequently Asked Question...",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref($v).faqTitle.$touch())),
            onKeypress: _withKeys(addFAQ, ["enter"])
          }, null, 34), [
            [_vModelText, faqTitle.value]
          ]),
          (_unref($v).faqTitle.$invalid && _unref($v).faqTitle.$dirty)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(getErrorMessage()), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_n_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            id: "answer-modal-add-button",
            variant: "primary",
            onClick: addFAQ,
            disabled: _unref($v).$invalid,
            loading: isLoading.value
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Add")
            ])),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_n_button, {
            id: "answer-modal-close-button",
            onClick: close,
            variant: "primary--outline"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Cancel")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})